import React from 'react';

export function NewHDDocumentStorage() {
  return (
    <div className="new-ha-document-storage">
      <h1>Document Storage</h1>
      <p>Specify where your healthcare documents should be stored and who should have access to them.</p>
    </div>
  );
}